import { UIMSocketEventHandler } from '../UIMSocketEventHandler.ts';
import { SocketLobbySend } from '../../../shared/scripts/socket/SocketLobbySend.ts';
import { CustomLinkUtils } from '../../../shared/scripts/ui_utils/CustomLinkUtils.ts';
import { UIUrlController } from '../../../shared/scripts/ui_html/UIUrlController.ts';
import { UIMDiscordActivityController } from './UIMDiscordActivityController.ts';
export class UIMDiscordSocketEventHandler extends UIMSocketEventHandler {
    // eslint-disable-next-line class-methods-use-this
    onStateSessionState() {
        const discordActivityController = UIMDiscordActivityController.getInstance();
        const roomId = CustomLinkUtils.extractRoomIdFromCustomLink(discordActivityController.referralOrReactivationType, discordActivityController.isInitialLoad) || UIUrlController.getRoomIdFromUrl();
        SocketLobbySend.joinChannel(discordActivityController.voiceChannelId, discordActivityController.serverProfile, discordActivityController.isInitialLoad, roomId);
    }
    // eslint-disable-next-line class-methods-use-this
    onChannelRoomUpdate(_roomData) {
    // Channel room updates drive Discord web CTAs; mobile has no equivalent UI yet.
    }
}
